import { useQuery } from "@tanstack/react-query";
import { api, config } from "../lib/api.js";
import { PageHeader } from "../components/PageHeader.jsx";
import { EmptyState } from "../components/EmptyState.jsx";

export function Trending() {
  const { data, isLoading } = useQuery({
    queryKey: ["trending"],
    queryFn: api.trending,
    enabled: config.hasBase,
    refetchInterval: 60_000
  });
  if (!config.hasBase) return <EmptyState title="Backend not configured" description="Configure VITE_API_BASE / VITE_API_TOKEN." />;
  if (isLoading) return <div className="subtle">Loading…</div>;
  const tags = data?.hashtags || [];
  if (tags.length === 0) return <EmptyState title="No trending data yet" description="Browse your LinkedIn feed and hashtag pages with the extension installed." />;

  const max = Math.max(...tags.map((t) => Number(t.total) || 1));

  return (
    <>
      <PageHeader title="Trending hashtags" subtitle="Aggregated from your feed in the last 24h." />
      <div className="card">
        <div className="flex flex-wrap gap-2">
          {tags.map((t) => {
            const size = 0.85 + (Number(t.total) / max) * 1.4;
            return (
              <span key={t.hashtag} className="px-3 py-1 rounded-full bg-white/5 border border-white/10" style={{ fontSize: `${size}rem` }}>
                #{t.hashtag} <span className="subtle">{t.total}</span>
              </span>
            );
          })}
        </div>
      </div>
    </>
  );
}
